import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Speedometer02 = function Speedometer02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M22 12c0 5.5228-4.4772 10-10 10S2 17.5228 2 12m20 0c0-5.5228-4.4772-10-10-10m10 10h-2.5M2 12C2 6.4772 6.4772 2 12 2M2 12h2.5M12 2v2.5m7.0784.5-5.5785 5.5m5.5785 8.5784-.2039-.2039c-.6918-.6918-1.0377-1.0377-1.4414-1.2851a4 4 0 0 0-1.1562-.4789C15.8166 17 15.3274 17 14.349 17H9.651c-.9784 0-1.4676 0-1.928.1106a4 4 0 0 0-1.1561.4789c-.4037.2474-.7496.5933-1.4414 1.2851l-.2039.2038M4.9216 5l1.7365 1.7364M14 12c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2"
    })
  }));
};
export default Speedometer02;